/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DocumentDto } from './DocumentDto';
import type { FinancierShopsGroup } from './FinancierShopsGroup';
import type { PhoneNumber } from './PhoneNumber';
import type { ShopFinancierDetailDto } from './ShopFinancierDetailDto';
import type { ShopPaymentChannelDto } from './ShopPaymentChannelDto';
export type InstallmentShopDto = {
    creationToken?: string;
    id?: string;
    shopReference?: string;
    name: string;
    address: string;
    lineId?: string;
    facebookUrl: string;
    phoneNumbers: Array<PhoneNumber>;
    status?: InstallmentShopDto.status;
    expireAt?: string;
    avatarUrl?: string;
    paymentChannels?: Array<ShopPaymentChannelDto>;
    financier?: ShopFinancierDetailDto;
    financierShopsGroup?: FinancierShopsGroup;
    financierShopContractUrl?: Array<DocumentDto>;
    taxPayerName?: string;
    taxId?: string;
    registeredAddress?: string;
};
export namespace InstallmentShopDto {
    export enum status {
        ACTIVE = 'ACTIVE',
        WAITING_FOR_APPROVE = 'WAITING_FOR_APPROVE',
        EXPIRED = 'EXPIRED',
        SUSPENDED = 'SUSPENDED',
    }
}

